import type { FetchLocationGeocodeResponse } from '@rover/types';

export default function fetchLocationGeocodeResponseFactory(): FetchLocationGeocodeResponse {
  return {
    lat: '',
    lng: '',
    locationAccuracy: '5161',
    locationType: '',
    rawLocationTypes: [''],
  };
}
